(function(){
    angular.module('tmx-app')
        .run(['$templateCache', function($templateCache){
            $templateCache.put('partials/menu-toggle.tmpl.html',
                '<md-button id="{{section.name}}" class="md-button-toggle colors-menus side-padding-0"\n' +
        '  ng-click="toggle()"\n' +
        '  aria-controls="side-menu-{{section.name | nospace}}"\n' +
        '  flex layout="row"\n' +
        '  aria-expanded="{{isOpen()}}"'+
        '  ng-class="{\'active\' : inCurrentState(section),\'focus\' : clicked}" >\n' +
        '<md-icon class="colors-menus md-background md-hue-3 material-icons margin-top-2 margin-left-8 margin-right-8" style="margin-bottom:3px !important;"  ng-class="{\'active\' : inCurrentState(section)}">{{section.icon}}</md-icon>'+
        '  <span class="toggle-menu-span">{{section.label | translate}}</span>\n' +
          '<md-icon class="ng-scope ng-isolate-scope material-icons pull-right md-toggle-icon toggle-menu-arrow"  ng-class="{\'toggled\' : isOpen()}">keyboard_arrow_right</md-icon>\n' +
        '</md-button>\n' +
        '<ul ng-show="isOpen()" id="side-menu-{{section.name | nospace}}" class="menu-toggle-list padding-left-24">\n' +
        '  <li ng-repeat="page in section.pages">\n' +
        '    <menu-link ng-if="!page.disabledEntity"  section="page"></menu-link>\n' +
        '  </li>\n' +
        '</ul>\n' +
        '');
        }])
        .directive('menuToggle', [ '$timeout','menu','$state', function($timeout,menu,$state) {
      
      
            var directive={
                scope:{
                    section:'=',
                    active:'='
                },
                templateUrl:'partials/menu-toggle.tmpl.html',
                link:function($scope, $element ) { //link function

                    $scope.clicked = false;
                    $scope.isOpen = function() {
                        var result=menu.isSectionSelected($scope.section);
                        return result;
                    };

                    $scope.toggle = function() {
                        $scope.clicked =  !$scope.clicked;
                        menu.toggleSelectSection($scope.section);
                    };
          
            // $scope.isActive = function() {
            //     if($scope.active=="true")
            //       return true;
            //     else
            //       return false;
            // };
                    $scope.inCurrentState=inCurrentState;
                }
            };
      
            function inCurrentState(state){
                var currentStateArray = $state.current.name.split('.');
                for(var i=0;i<currentStateArray.length;i++) {
                    if(angular.lowercase(state.name)==currentStateArray[i])

                        return true;
                }
                return false;
            }

            return directive;

        }]);

})();